export interface Middleware<T = any, U = any> {
  (this: U, payload: T, next: Next<U, T>): T
}

export interface MiddlewareStartup<T = any, U = any> {
  (this: U, payload: T, next?: Next): T
}

export type Next<T = any, U = any> = (this: U, payload: T) => any

export function createMiddleware<T = any, U = any>(
  middlewares: Middleware<T, U>[] = []
): MiddlewareStartup<T, U> {
  let funcBody = `typeof next === 'function' ? next.call(this,payload) : payload`
  for (let index = middlewares.length - 1; index >= 0; index--) {
    const nextFuncBody = 'payload => ' + funcBody
    funcBody = `$${index + 1}(payload, ${nextFuncBody})`
  }

  return new Function(
    ...middlewares.map((_, index) => '$' + (index + 1)),
    `return (payload,next) => ${funcBody}`
  )(...middlewares) as MiddlewareStartup<T, U>
}
